import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { INTER_TYPE_INIT_LOADING, INTER_TYPE_INIT_SUCCESS, INTER_TYPE_INIT_FAIL } from '@/store/types'

export const state = {
  init: 0,
  initErr: [],
  menu: {}
}

const getters = {

}

const mutations = {
  [INTER_TYPE_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [INTER_TYPE_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data ? data.menu : null
    state.iniErr = []
  },
  [INTER_TYPE_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.iniErr = err
  }
}

const actions = {
  async interTypeManagement({ commit, rootState }) {
    const apiUrl = rootState.app.menu.interTypeManagement
    commit(INTER_TYPE_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(INTER_TYPE_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(INTER_TYPE_INIT_FAIL, extractMessages(error))
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
